import Vue from 'vue'
import ECharts from 'echarts'
Vue.prototype.$echarts = ECharts
